import React from "react";
import dynamic from "next/dynamic";
const Fancybox = dynamic(() => import("../Fancybox"));
const Faq = dynamic(() => import("../Index/Faq"), { ssr: false });
import Ribbon from "../Ribbon";
const CheckIn = dynamic(() => import("./CheckIn"), { ssr: false });
const Description = dynamic(() => import("./Description"));
const Distance = dynamic(() => import("./Distance"), { ssr: false });
import FloorPlan from "./FloorPlan";
const HeaderCard = dynamic(() => import("./HeaderCard"));
const SonDakika = dynamic(() => import("./SonDakika"));
import Icon from "./Icons";
import IncludedPrice from "./IncludedPrice";
import Pool from "./Pool";
const Prices = dynamic(() => import("./Prices"));
const Properties = dynamic(() => import("./Properties"), { ssr: false });
import Wrapper from "./Wrapper";
import { useTranslation } from "../../context/TranslationContext";
import KiralaGelBanner from "../KiralaGelBanner";

const Right = ({
  showAvailability,
  setShowAvailability,
  page,
  isPhone,
  deviceType,
  onSelectSonDakika,
}) => {
  const {
    faqVideoTitle,
    poolDimensions,
    childPool,
    indoorPool,
    reviewCtaTitle,
    reviewCtaThisVilla,
    reviewCtaText,
    googleWriteReview,
  } = useTranslation();

  return (
    <div className="overflow-hidden w-full ">
      <Wrapper classname="relative">
        <HeaderCard page={page} />
        <SonDakika page={page} onSelect={onSelectSonDakika} />
        {page.onecikan ? <Properties onecikan={page.onecikan} /> : null}
        {page.gavel == "0" && (
          <div className="flex flex-col lg:flex-col xl:flex-row bg-white lg:border-[3px] border-detail-border-color rounded  lg:pt-9 lg:pb-8 lg:pl-9 lg:pr-8 px-3 sm:px-[1.3rem] pt-3">
            {page.ribbon || page.ribbon2 ? (
              <div className="flex flex-col ml:flex-row text-center gap-3 mt-1 pb-3 justify-center lg:hidden">
                {page.ribbon && <Ribbon>{page.ribbon}</Ribbon>}
                {page.ribbon2 && <Ribbon>{page.ribbon2}</Ribbon>}
              </div>
            ) : (
              ""
            )}
            <Prices
              showAvailability={showAvailability}
              setShowAvailability={setShowAvailability}
              ProductId={page.id}
              start2={page.start2}
            />
            <div className="xl:w-[340px] lg:w-full">
              <Fancybox>
                <div
                  className="relative cursor-pointer  rounded-md overflow-hidden hidden lg:block"
                  data-fancybox="video-gallery1"
                  data-src="https://www.youtube.com/watch?v=E7eHfwLydYY"
                >
                  <div className="bg-DetailVideoBg w-full h-56"></div>
                  <div className="absolute top-2/4 left-2/4 flex flex-col items-center w-full lg:w-auto transform -translate-x-2/4 -translate-y-2/4">
                    <Icon name={"PlayButtonBig"} size={41}></Icon>
                    <span className="font-bold text-white text-sm mt-1.5">
                      {faqVideoTitle}
                    </span>
                  </div>
                </div>
              </Fancybox>
              <IncludedPrice
                data={[page.fiyata_dahil, page.fiyata_dahil_olmayanlar]}
              />
            </div>
          </div>
        )}
        <CheckIn page={page} />
        <div className="lg:hidden">
          <KiralaGelBanner
            src={"/images/kiralagel-banner/575x260.png"}
            listingPage={true}
            heightClass="h-52"
            deviceType={deviceType}
          />
        </div>
        <Description title={page.title2} icerik={page.icerik} />
        <div className="flex -mt-20 relative items-start flex-col xl:flex-row bg-[#EFF5F7] lg:bg-transparent">
          <div className="w-full flex flex-col gap-y-3 xl:w-[274px] flex-shrink-0 px-5 sm:px-[1.3rem] lg:px-0  order-1 xl:order-2 relative ml-0.5"></div>
          <div className="w-full flex gap-x-3 px-5 sm:px-[1.3rem] lg:px-0 relative flex-col gap-y-2 md:flex-row">
            {page.yuzme_havuzu != "Yok" && (
              <Pool
                title={poolDimensions}
                boy={page.yuzme_havuzu_uzunluk}
                genislik={page.yuzme_havuzu_genislik}
                derinlik={page.yuzme_havuzu_derinlik}
              ></Pool>
            )}
            {page.cocuk_havuzu && page.cocuk_havuzu != "Yok" && (
              <Pool
                title={childPool}
                boy={page.cocuk_havuzu_uzunluk}
                genislik={page.cocuk_havuzu_genislik}
                derinlik={page.cocuk_havuzu_derinlik}
              ></Pool>
            )}
            {page.kapali_havuz && page.kapali_havuz != "Yok" && (
              <Pool
                title={indoorPool}
                boy={page.kapali_havuz_uzunluk}
                genislik={page.kapali_havuz_genislik}
                derinlik={page.kapali_havuz_derinlik}
              ></Pool>
            )}
          </div>
        </div>
        <Distance
          id={page.id}
          harita={page.harita}
          enlem={page.enlem}
          boylam={page.boylam}
          baslik={page.baslik}
        />
      </Wrapper>
      {/* {page.harita && <Maparea lat={page.enlem} lng={page.boylam} />} */}
      <Wrapper classname="relative sm:mt-56 bg-[#EFF5F7] sm:bg-transparent">
        <Faq data={page.faq} />
        
        {/* Yorum Yap / Google Review CTA */}
        <div className="w-full mt-8 pb-12 px-3 sm:px-[1.3rem] lg:px-0">
          <div className="bg-teklif-gra rounded-md p-8 lg:p-10 flex flex-col md:flex-row items-center justify-between gap-6 lg:gap-10 shadow-md relative overflow-hidden">
            
            {/* Giant Faint Background Icon */}
            <span className="absolute -left-12 -top-12 opacity-10 pointer-events-none z-0">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="w-72 h-72">
                <g transform="matrix(1, 0, 0, 1, 27.009001, -39.238998)">
                  <path d="M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.225 -9.424 56.474 -10.686 57.324 L -10.686 60.325 L -6.842 60.325 C -4.608 58.235 -3.264 55.159 -3.264 51.509 Z" fill="#ffffff"/>
                  <path d="M -14.754 63.239 C -11.516 63.239 -8.801 62.157 -6.821 60.324 L -10.685 57.323 C -11.761 58.044 -13.138 58.469 -14.754 58.469 C -17.869 58.469 -20.518 56.364 -21.464 53.535 L -25.276 53.535 L -25.276 56.453 C -23.414 60.188 -19.542 63.239 -14.754 63.239 Z" fill="#ffffff"/>
                  <path d="M -21.464 53.535 C -21.711 52.801 -21.838 52.016 -21.838 51.213 C -21.838 50.407 -21.711 49.623 -21.464 48.889 L -21.464 45.971 L -25.276 45.971 C -26.046 47.508 -26.488 49.225 -26.488 51.213 C -26.488 53.197 -26.046 54.918 -25.276 56.453 L -21.464 53.535 Z" fill="#ffffff"/>
                  <path d="M -14.754 43.955 C -12.983 43.955 -11.396 44.57 -10.146 45.749 L -6.741 42.34 C -8.802 40.418 -11.516 39.239 -14.754 39.239 C -19.542 39.239 -23.414 42.29 -25.276 46.025 L -21.464 48.943 C -20.518 46.113 -17.869 43.955 -14.754 43.955 Z" fill="#ffffff"/>
                </g>
              </svg>
            </span>

            <div className="flex items-center gap-6 text-center md:text-left z-10 relative">
              <div className="hidden md:flex bg-white p-4 shadow-sm flex-shrink-0 rounded-full">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="w-10 h-10">
                  <g transform="matrix(1, 0, 0, 1, 27.009001, -39.238998)">
                    <path d="M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.225 -9.424 56.474 -10.686 57.324 L -10.686 60.325 L -6.842 60.325 C -4.608 58.235 -3.264 55.159 -3.264 51.509 Z" fill="#4285F4"/>
                    <path d="M -14.754 63.239 C -11.516 63.239 -8.801 62.157 -6.821 60.324 L -10.685 57.323 C -11.761 58.044 -13.138 58.469 -14.754 58.469 C -17.869 58.469 -20.518 56.364 -21.464 53.535 L -25.276 53.535 L -25.276 56.453 C -23.414 60.188 -19.542 63.239 -14.754 63.239 Z" fill="#34A853"/>
                    <path d="M -21.464 53.535 C -21.711 52.801 -21.838 52.016 -21.838 51.213 C -21.838 50.407 -21.711 49.623 -21.464 48.889 L -21.464 45.971 L -25.276 45.971 C -26.046 47.508 -26.488 49.225 -26.488 51.213 C -26.488 53.197 -26.046 54.918 -25.276 56.453 L -21.464 53.535 Z" fill="#FBBC05"/>
                    <path d="M -14.754 43.955 C -12.983 43.955 -11.396 44.57 -10.146 45.749 L -6.741 42.34 C -8.802 40.418 -11.516 39.239 -14.754 39.239 C -19.542 39.239 -23.414 42.29 -25.276 46.025 L -21.464 48.943 C -20.518 46.113 -17.869 43.955 -14.754 43.955 Z" fill="#EA4335"/>
                  </g>
                </svg>
              </div>
              <div className="pr-0 md:pr-4">
                <h4 className="text-2xl lg:text-3xl font-bold text-white mb-2 drop-shadow-sm">{reviewCtaTitle}</h4>
                <p className="text-white opacity-95 text-sm lg:text-base leading-relaxed max-w-2xl">
                  <strong className="font-bold">{page.baslik || reviewCtaThisVilla}</strong> {reviewCtaText}
                </p>
              </div>
            </div>
            <a 
              href="https://g.page/r/Cc84qp7cJY5HEBM/review" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white hover:bg-gray-100 text-primary font-bold text-sm lg:text-base px-8 py-4 w-full md:w-auto text-center transition-colors whitespace-nowrap shadow-md flex-shrink-0 z-10 rounded"
            >
              {googleWriteReview}
            </a>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default Right;
